import React from "react";
import { Typography } from "@mui/material";

const SavedAddresses = () => {
  return (
    <>
      <Typography variant="h5" gutterBottom>
        Saved Addresses
      </Typography>
      <Typography>Here you can view and edit your saved addresses.</Typography>
    </>
  );
};

export default SavedAddresses;
